/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import * as Urql from 'urql';

import type * as Types from '../../../../../../../../generated/graphql/types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CashbackOfferQueryVariables = Types.Exact<{
  market: Types.Market;
  platform: Types.Platform;
  productId: Types.Scalars['String']['input'];
}>;

export type CashbackOfferQuery = {
  __typename?: 'Query';
  cashbackOffer?: {
    __typename?: 'CashbackOffer';
    displayAmount?: number;
    displayLabel?: string;
    link: {
      __typename?: 'CashbackOfferLink';
      url: string;
      target: Types.CashbackOfferLinkTarget;
    };
  };
};

export const CashbackOfferDocument = /*#__PURE__*/ `
    query CashbackOffer($market: Market!, $platform: Platform!, $productId: String!) {
  cashbackOffer(market: $market, platform: $platform, productId: $productId) {
    displayAmount
    displayLabel
    link {
      url
      target
    }
  }
}
    `;

export function useCashbackOfferQuery(
  options: Omit<Urql.UseQueryArgs<CashbackOfferQueryVariables>, 'query'>,
) {
  return Urql.useQuery<CashbackOfferQuery, CashbackOfferQueryVariables>({
    query: CashbackOfferDocument,
    ...options,
  });
}
